import {AxiosInstance} from "axios";
import Sms from "../model/sms/Sms";

/**
 * Api for text messages (sms).
 */
export default class SmsApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	fetchTextMessages(): Promise<Sms[]> {
		const url = `/api/web/sms`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(Sms.fromJson));
	}
}